/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Bed } from './Bed';
import {
    BedFromJSON,
    BedFromJSONTyped,
    BedToJSON,
    BedToJSONTyped,
} from './Bed';

/**
 * 
 * @export
 * @interface FindOneBed200Response
 */
export interface FindOneBed200Response {
    /**
     * 
     */
    data?: Bed;
}

/**
 * Check if a given object implements the FindOneBed200Response interface.
 */
export function instanceOfFindOneBed200Response(value: object): value is FindOneBed200Response {
    return true;
}

export function FindOneBed200ResponseFromJSON(json: any): FindOneBed200Response {
    return FindOneBed200ResponseFromJSONTyped(json, false);
}

export function FindOneBed200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindOneBed200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : BedFromJSON(json['data']),
    };
}

export function FindOneBed200ResponseToJSON(json: any): FindOneBed200Response {
    return FindOneBed200ResponseToJSONTyped(json, false);
}

export function FindOneBed200ResponseToJSONTyped(value?: FindOneBed200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': BedToJSON(value['data']),
    };
}

